module.exports = __webpack_public_path__ + "static/media/taraDefaultOne.cbfcc037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraDefaultOne.svg
// module id = 611
// module chunks = 0